<body>
  <app-header></app-header>
  <app-nav-menu></app-nav-menu>
  <div class="container-fluid">
    <router-outlet></router-outlet>
    <app-spinner-wheel></app-spinner-wheel>
  </div>
</body>
